import { useState } from 'react'
import { SlOptions } from 'react-icons/sl'
import ModalSponsorsOptions from './ModalSponsorsOptions'

export default function ButtonSponsorsOptions({ sponsor }) {
  const [isOpen, setIsOpen] = useState(false)

  function handleOnOpenModel() {
    setIsOpen(true)
  }

  function handleOnCloseModel() {
    setIsOpen(false)
  }
  return (
    <>
      <button
        onClick={handleOnOpenModel}
        className="border-2 border-muted-500 bg-white p-2 hover:bg-muted-500"
      >
        <SlOptions size={16} />
      </button>
      <ModalSponsorsOptions
        isOpen={isOpen}
        onClose={handleOnCloseModel}
        sponsor={sponsor}
      />
    </>
  )
}
